"use strict";
exports.__esModule = true;
exports.postPhoneVerificationResponse = exports.getUserAccountResponse = void 0;
exports.getUserAccountResponse = {
    user_account: {
        first_name: 'Mocked',
        last_name: 'User',
        email: 'mocked.user@getflex.com',
        phone_number: '15555551234',
        customer_public_id: 'Ww0W6x6pk1g7YFtI3Eh1XCZIy301',
        email_verified: true
    }
};
exports.postPhoneVerificationResponse = {
    user_account: {
        first_name: 'Mocked',
        last_name: 'User',
        email: 'mocked.user@getflex.com',
        phone_number: '15555551234',
        customer_public_id: 'Ww0W6x6pk1g7YFtI3Eh1XCZIy301',
        email_verified: true
    }
};
